<div [ngClass]="options.ngClass">

  <ng-container *ngIf="state.isArray">
    <quick-preview-panel
      [heading]="defaultSectionName"
      [collapsable]="collapsible"
      [color]="'primary'"
    >
      <div class="p-3">
        <data-table [items]="item"></data-table>
      </div>
    </quick-preview-panel>
  </ng-container>

  <ng-container *ngIf="state.isComposite">
    <quick-preview-panel
      *ngFor="let s of state.sectionNames"
      [color]="'primary'"
      [collapsable]="collapsible"
      [heading]="state.sectionDefs[s].heading || s"
      [ngClass]="state.sectionDefs[s].ngClass || 'mb-4'"
    >
      <div class="p-3">
        <div class="row p-0 m-0">
          <div
            *ngFor="let prop of state.sectionProperties[s]"
            class="col-12 col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 p-0 m-0"
            [ngClass]="prop.outerNgClass"
          >
            <div class="p-0 pe-2 pb-2" [ngClass]="prop.innerNgClass">
              <ng-container
                *ngIf="prop.renderTemplate"
                [ngTemplateOutlet]="prop.renderTemplate"
                [ngTemplateOutletContext]="{
                  propertyName: prop.propertyName,
                  propertyDef: prop,
                  propertyValue: item[prop.propertyName],
                  objectValue: item
                }"
              >
              </ng-container>
              <ng-container *ngIf="!prop.renderTemplate">
                <div class="fw-normal">{{prop.heading || prop.propertyName}}</div>
                <div class="fw-light" [ngClass]="prop.valueNgClass">
                  <ng-container
                    [ngTemplateOutlet]="prop.valueRenderTemplate || defaultPropertyValueRenderTemplate"
                    [ngTemplateOutletContext]="{
                      propertyName: prop.propertyName,
                      propertyDef: prop,
                      propertyValue: item[prop.propertyName],
                      objectValue: item
                    }"
                  >
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </quick-preview-panel>
  </ng-container>

  <ng-container *ngIf="!state.isArray && !state.isComposite">
    {{item | json}}
  </ng-container>
</div>

<ng-template
  #defaultPropertyValueRenderTemplate let-propertyValue=propertyValue let-propertyDef=propertyDef
>
  <ng-container [ngSwitch]="propertyDef['reflectedType']">
    <ng-container *ngSwitchCase="'array'">
      Array ({{propertyValue['length']}})
    </ng-container>
    <ng-container *ngSwitchCase="'composite'">
      Object
    </ng-container>
    <ng-container *ngSwitchCase="'string'">
      <span [ngClass]="propertyDef['valueNgClass'] || 'text-secondary'">{{propertyValue}}</span>
    </ng-container>
    <ng-container *ngSwitchCase="'date'">
      <span [ngClass]="propertyDef['valueNgClass'] || 'text-secondary'">{{propertyValue | date}}</span>
    </ng-container>
    <ng-container *ngSwitchCase="'boolean'">
      <span class="text-primary" [ngClass]="{
        'text-danger': ! propertyValue
        }">{{propertyValue}}</span>
    </ng-container>
    <ng-container *ngSwitchCase="'number'">
      <span [ngClass]="propertyDef['valueNgClass'] || 'text-primary'">{{propertyValue}}</span>
    </ng-container>
    <ng-container *ngSwitchCase="'null'">
      <span [ngClass]="propertyDef['valueNgClass'] || 'text-primary'">null</span>
    </ng-container>
    <ng-container *ngSwitchCase="'undefined'">
      <span [ngClass]="propertyDef['valueNgClass'] || 'text-danger'">undefined</span>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <span [ngClass]="propertyDef['valueNgClass'] || 'text-secondary'">{{propertyValue}}</span>
    </ng-container>
  </ng-container>

</ng-template>
